import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ObjectList from "../containers/ObjectList";
import PeoplePerDeparment from "../containers/PeoplePerDepartment";
import { Constants } from "../libs/Constants";
import { getList } from "../libs/dbFunctions";
import { getDefaultPeriodSelection } from "../libs/periodLib";
import "./Home.css";

export default function List(props) {
  const [selectedPeriod, setSelectedPeriod] = useState(null);

  useEffect(() => {
    onLoad();
  }, [props.isAuthenticated, props.userObj]);

  async function onLoad() {
    try {
      //fetch the period rows from database
      const periodDetails = await getList(
        Constants.dbTypes.PERIOD,
        props.activeCompany
      );
      if (periodDetails && periodDetails.length > 0) {
        let periodResponse = getDefaultPeriodSelection(periodDetails);
        if (periodResponse) {
          setSelectedPeriod(periodResponse.currentPeriod);
        }
      }
    } catch (e) {
      toast.error(e);
    }
  }

  function renderParticipantPerDepartment() {
    return (
      <PeoplePerDeparment
        period={selectedPeriod}
        activeCompany={props.activeCompany}
      ></PeoplePerDeparment>
    );
  }
  return (
    <div className="container p5">
      <h2 className="text-capitalize mb-2">People</h2>
      {renderParticipantPerDepartment()}
      <ObjectList
        type={Constants.dbTypes.USER}
        hideTitle={true}
        pagination={true}
        {...props}
      />
    </div>
  );
}
